import { useTranslation } from 'react-i18next';
import { useCallback } from 'react';
import { Link } from 'react-router-dom';
import { features } from '@/config/flavor';
import '@/app/layout/Topbar.css';

interface TopbarProps {
  readonly isScrolled?: boolean;
}

/**
 * Topbar
 */
function Topbar({ isScrolled = false }: TopbarProps) {
  const { t, i18n } = useTranslation('common');

  const toggleLanguage = useCallback(() => {
    const nextLang = i18n.language === 'he' ? 'en' : 'he';
    void i18n.changeLanguage(nextLang);
  }, [i18n]);

  return (
    <header className={`topbar${isScrolled ? ' topbar-scrolled' : ''}`}>
      <div className="topbar-brand">
        <Link to="/" className="topbar-brand-link">
          <img src="/icons/icon-192.png" alt="" className="topbar-logo" />
          <h1 className="topbar-title">{features.appName}</h1>
        </Link>
      </div>

      <div className="topbar-actions">
        <div className="topbar-powered-by">
          <span>{features.isIdf ? 'מופעל על ידי' : 'powered by'}</span>
          <a
            href="https://ezhard.co.il"
            target="_blank"
            rel="noopener noreferrer"
            className="topbar-powered-ezhard"
            aria-label="EZHard Website"
          >
            <span className="topbar-ezhard-logo" aria-hidden="true" />
            EZHard
          </a>
        </div>
        <Link
          to="/?help=true"
          className="topbar-terms-link"
          aria-label={t('actions.help', 'Help')}
          id="topbar-help-link"
        >
          <span className="material-symbols-rounded topbar-terms-icon" aria-hidden="true">
            help
          </span>
        </Link>


        {features.languageSwitcher && (
          <button
            type="button"
            className="topbar-lang-switcher"
            onClick={toggleLanguage}
            aria-label={t('actions.switchLanguage')}
          >
            <span className="material-symbols-rounded topbar-lang-icon" aria-hidden="true">
              translate
            </span>
            <span>{i18n.language === 'he' ? 'EN' : 'עב'}</span>
          </button>
        )}
      </div>
    </header>
  );
}

export { Topbar };

